import { isNonEmptyArray, isObject, validateString } from '..'
import { Properties } from '../entities'

export const InstitutionProperties = Object.freeze({
  ACRONYM: Properties.ACRONYM,
  ADDRESS: Properties.ADDRESS,
  CITY: Properties.CITY,
  COUNTRY: Properties.COUNTRY,
  DESCRIPTION: Properties.DESCRIPTION,
  GLOBAL_MESSAGE: Properties.GLOBAL_MESSAGE,
  MANAGED: Properties.MANAGED,
  NAME: Properties.NAME,
  ZIPCODE: Properties.ZIPCODE,
  HOSPITAL_DEPARTMENTS: Properties.HOSPITAL_DEPARTMENTS
})

export const INSTITUTION_VALIDATORS = (keys = []) => {
  const validators = [
    { key: Properties.ACRONYM, validator: i => validateString(i.acronym, { notEmpty: true }) },
    { key: Properties.ADDRESS, validator: i => validateString(i.address, { notEmpty: true }) },
    { key: Properties.CITY, validator: i => validateString(i.city, { notEmpty: true }) },
    { key: Properties.COUNTRY, validator: i => isObject(i.country) },
    { key: Properties.NAME, validator: i => validateString(i.name, { notEmpty: true }) },
    { key: Properties.ZIPCODE, validator: i => validateString(i.zipcode, { notEmpty: true }) }
  ]

  return isNonEmptyArray(keys) ? validators.filter(v => keys.includes(v.key)) : validators
}

export const getName = i => {
  return i.name
}

export const getAcronym = i => {
  return i.acronym
}

export const getAddress = i => {
  return i.address
}

export const getCity = i => {
  return i.city
}

export const getCountry = i => {
  return isObject(i.country) ? i.country.name : null
}

export const getDescription = i => {
  return i.description
}

export const getGlobalMessage = i => {
  return i.globalMessage
}

export const getZipcode = i => {
  return i.zipcode
}

export class Institution {
  constructor ({ id, acronym, address, city, country, description, globalMessage = null, hospitalDepartments, managed, name, sectors, zipcode } = {}) {
    this.id = id ?? -1
    this.acronym = acronym ?? ''
    this.address = address ?? ''
    this.city = city ?? ''
    this.country = country ?? null
    this.description = description ?? ''
    this.globalMessage = globalMessage
    this.hospitalDepartments = isNonEmptyArray(hospitalDepartments) ? hospitalDepartments : []
    this.managed = managed ?? false
    this.name = name ?? ''
    this.sectors = isNonEmptyArray(sectors) ? sectors : []
    this.zipcode = zipcode ?? ''
  }

  toRequestBody = () => {
    const body = { ...this }

    body.country = this.country === null ? null : this.country.code

    return body
  }
}
